import { render } from "./WalletReversal.vue?vue&type=template&id=aacd2e58"
import script from "./WalletReversal.vue?vue&type=script&lang=js"
export * from "./WalletReversal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__